import { render, staticRenderFns } from "./FinancesTransactionsAddExpence.vue?vue&type=template&id=c5433a94&scoped=true"
import script from "./FinancesTransactionsAddExpence.vue?vue&type=script&lang=js"
export * from "./FinancesTransactionsAddExpence.vue?vue&type=script&lang=js"
import style0 from "./FinancesTransactionsAddExpence.vue?vue&type=style&index=0&id=c5433a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5433a94",
  null
  
)

export default component.exports